import { gql } from '@apollo/client/core';

export default gql`
  query downloadDMAResultExcel ( $data: String!) {
      downloadDMAResultExcel( data: $data)
  }
`;
